import React, { memo } from "react";
import { Stepper } from "uikit";

const ValueStepper: React.FC<ValueStepper.Props> = memo(
	({ width, disabled, value, onChange, ...props }) => (
		<Stepper
			{...props}
			disabled={disabled}
			decimalCount={2}
			width={width || "90px"}
			value={value || 0}
			onChange={onChange}
		/>
	),
);

declare namespace ValueStepper {
	interface Props extends Stepper.Props {
		disabled?: boolean;
		value?: number;
		onChange?: (val: any) => void;
		width?: string;
	}
}

export default ValueStepper;
